// Client-side mirror of SetOrganizationVerifiedDomainRequest.NormalizeDomain / IsAcceptableDomain,
// so staff get feedback before submit. The registration gate matches on a bare lowercase host.

const HOSTNAME_RE = /^(?=.{1,253}$)([a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,}$/;

/** Lowercase, host-only (strips anything up to and including '@'). */
export function normalizeDomain(raw: string): string {
  let d = raw.trim().toLowerCase();
  const at = d.indexOf("@");
  if (at >= 0) d = d.slice(at + 1);
  return d;
}

/** True if blank (a request to clear the domain) or a valid bare hostname the gate can match. */
export function isAcceptableDomain(raw: string): boolean {
  if (raw.trim() === "") return true;
  return HOSTNAME_RE.test(normalizeDomain(raw));
}
